let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("98YiA")).then(() => parcelRequire('1L428'));